import React, { useContext, useMemo } from 'react';
import { User } from 'models';
import { HStack } from '@chakra-ui/react';
import { UserAvatar } from 'Organisms/UserAvatar';
import { Typography } from 'Tokens/Typography';
import { getFirstName } from 'utils/userFirstName';
import { useTranslation } from 'utils/translation';

export const CELSIA_WELCOME_MODAL = 'celsia_welcome_modal_is_closed';

export const HomeWelcomeSection = ({ user }: { user: User | null | undefined }) => {
    const { t } = useTranslation('home');
    const firstName = useMemo(() => getFirstName(user), [user]);

    return (
        <HStack mb="24px" spacing="6px">
            {user != null && (
                <Typography variant="h1" color="text.default">
                    {t('home:welcomeComma')}
                </Typography>
            )}
            {user != null && <UserAvatar size={"welcomeAvatar"} user={user} />}
            <Typography variant="h1" color="text.default">
                {firstName}
            </Typography>
        </HStack>
    );
};